module.exports = __webpack_public_path__ + "static/june-6-d40a9b8a612e8ae369c43b85dbc775ec.png";